/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_accionProyecto as accionProyecto,
  rec_Cargando as Cargando,
  rec_CerrarProyecto as CerrarProyecto,
  rec_EstadoError as EstadoError,
  rec_EstructuraPrincipal as EstructuraPrincipal,
  rec_JSXRuntime as JSXRuntime,
  rec_Nr as Nr,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_Sn as Sn,
  rec_TableroTareas as TableroTareas,
  rec_api as api,
  rec_esAdministrador as esAdministrador,
  rec_fO as fO,
  rec_fS as fS,
  rec_gr as gr,
  rec_ii as ii,
  rec_ko as ko,
  rec_lt as lt,
  rec_nw as nw,
  rec_oi as oi,
  rec_tw as tw,
  rec_zo as zo,
} from "../../runtime/index.jsx";
export function DetalleProyecto() {
  let e = (0, ReactCompiler.c)(47),
    { id: t } = lt(),
    [n, r] = (0, React.useState)(null),
    [i, a] = (0, React.useState)(``),
    [o, s] = (0, React.useState)(`tablero`),
    [c, l] = (0, React.useState)(!1),
    u;
  e[0] === t
    ? (u = e[1])
    : ((u = async () => {
        a(``);
        try {
          r(
            await api(`/proyectos/${t}`, {
              alRefrescar: r,
            }),
          );
        } catch (e) {
          a(e.message);
        }
      }),
      (e[0] = t),
      (e[1] = u));
  let f = u,
    p,
    m;
  (e[2] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((p = () => {
        let e = tw(`proyecto-tab`, `tablero`);
        fO.some((t) => t.id === e) && s(e);
      }),
      (m = []),
      (e[2] = p),
      (e[3] = m))
    : ((p = e[2]), (m = e[3])),
    (0, React.useEffect)(p, m));
  let h;
  e[4] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((h = function (e) {
        (s(e), nw(`proyecto-tab`, e));
      }),
      (e[4] = h))
    : (h = e[4]);
  let _ = h,
    v,
    y;
  (e[5] === f
    ? ((v = e[6]), (y = e[7]))
    : ((v = () => {
        f();
      }),
      (y = [f]),
      (e[5] = f),
      (e[6] = v),
      (e[7] = y)),
    (0, React.useEffect)(v, y));
  let b;
  e[8] === n?.miRol
    ? (b = e[9])
    : ((b = esAdministrador() || [`planner.proyectos.editar`, `planner.proyectos.miembros`, `planner.proyectos.eliminar`, `planner.proyectos.archivar`].some((c) => accionProyecto(n, c))),
      (e[8] = n?.miRol),
      (e[9] = b));
  let x = b,
    S;
  e[10] === x
    ? (S = e[11])
    : ((S = fO.filter((e) => !e.gestion || x)), (e[10] = x), (e[11] = S));
  let C = S,
    w,
    T;
  (e[12] !== n || e[13] !== o || e[14] !== C
    ? ((w = () => {
        n && !C.some((e) => e.id === o) && s(`tablero`);
      }),
      (T = [n, C, o]),
      (e[12] = n),
      (e[13] = o),
      (e[14] = C),
      (e[15] = w),
      (e[16] = T))
    : ((w = e[15]), (T = e[16])),
    (0, React.useEffect)(w, T));
  let E;
  e[17] !== o || e[18] !== C
    ? ((E = C.find((e) => e.id === o)?.C ?? TableroTareas),
      (e[17] = o),
      (e[18] = C),
      (e[19] = E))
    : (E = e[19]);
  let D = E,
    O = n?.estado === `COMPLETADO` || n?.estado === `CANCELADO`,
    k;
  e[20] !== f || e[21] !== t
    ? ((k = async function () {
        try {
          (await api(`/proyectos/${t}/reabrir`, {
            method: `POST`,
          }),
            f());
        } catch (e) {
          a(e.message);
        }
      }),
      (e[20] = f),
      (e[21] = t),
      (e[22] = k))
    : (k = e[22]);
  let A = k,
    j = n?.nombre ?? `Proyecto`,
    M;
  e[23] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((M = (
        <Sn
          to={`/organizacion`}
          className={`flex w-fit items-center gap-1 text-sm text-(--text) hover:text-(--text-h)`}
          children={[
            (0, JSXRuntime.jsx)(gr, {
              className: `h-4 w-4`,
            }),
            ` Organización`,
          ]}
        />
      )),
      (e[23] = M))
    : (M = e[23]);
  let N;
  e[24] !== f || e[25] !== i
    ? ((N = <EstadoError mensaje={i} onReintentar={f} />),
      (e[24] = f),
      (e[25] = i),
      (e[26] = N))
    : (N = e[26]);
  let P;
  e[27] !== D ||
  e[28] !== f ||
  e[29] !== O ||
  e[30] !== t ||
  e[31] !== n ||
  e[32] !== A ||
  e[33] !== o ||
  e[34] !== C
    ? ((P = n ? (
        <JSXRuntime.Fragment
          children={[
            O && (
              <div
                className={`flex flex-wrap items-center gap-2 rounded-2xl border border-(--border) bg-(--panel) px-3 py-2 text-sm text-(--text-h)`}
                children={[
                  (0, JSXRuntime.jsx)(oi, {
                    className: `h-4 w-4 shrink-0 text-(--text)`,
                  }),
                  <span
                    className={`flex-1`}
                    children={[
                      `Proyecto `,
                      n.estado === `COMPLETADO` ? `completado` : `cancelado`,
                      n.cerradoEn && ` el ${fS(n.cerradoEn.slice(0, 10))}`,
                      n.cerradoPorNombre && ` por ${n.cerradoPorNombre}`,
                      n.cierreNota && ` — ${n.cierreNota}`,
                    ]}
                  />,
                  accionProyecto(n, `planner.proyectos.reabrir`) && (
                    <button
                      type={`button`}
                      onClick={A}
                      className={zo}
                      children={`Reabrir`}
                    />
                  ),
                ]}
              />
            ),
            !O && accionProyecto(n, `planner.proyectos.cerrar`) && (
              <div
                className={`flex justify-end`}
                children={
                  <button
                    type={`button`}
                    onClick={() => l(!0)}
                    className={zo}
                    children={[
                      <Nr className={`mr-1 inline h-3.5 w-3.5`} />,
                      ` Terminar proyecto`,
                    ]}
                  />
                }
              />
            ),
            <div
              className={`flex gap-1 overflow-x-auto border-b border-(--border)`}
              children={C.map((e) => (
                <button
                  key={e.id}
                  type={`button`}
                  onClick={() => {
                    (_(e.id),
                      e.id === `gantt` &&
                        ko(`ABRIR_GANTT`, `GANTT`, Number(t)));
                  }}
                  className={`whitespace-nowrap border-b-2 px-3 py-2 text-sm font-medium transition ${o === e.id ? `border-(--accent) text-(--text-h)` : `border-transparent text-(--text) hover:text-(--text-h)`}`}
                  children={e.label}
                />
              ))}
            />,
            <div
              className={`animar-entrada`}
              children={
                <React.Suspense
                  fallback={
                    <div
                      className={`flex items-center gap-2 text-sm text-(--text)`}
                      children={[
                        (0, JSXRuntime.jsx)(ii, {
                          className: `h-4 w-4 animate-spin`,
                        }),
                        ` Cargando…`,
                      ]}
                    />
                  }
                  children={<D key={`${t}-${o}`} proyecto={n} onCambio={f} />}
                />
              }
            />,
          ]}
        />
      ) : (
        <Cargando
          variante={`tarjetas`}
          cantidad={4}
          etiqueta={`Abriendo el proyecto`}
        />
      )),
      (e[27] = D),
      (e[28] = f),
      (e[29] = O),
      (e[30] = t),
      (e[31] = n),
      (e[32] = A),
      (e[33] = o),
      (e[34] = C),
      (e[35] = P))
    : (P = e[35]);
  let F;
  e[36] !== N || e[37] !== P
    ? ((F = <div className={`flex flex-col gap-4`} children={[M, N, P]} />),
      (e[36] = N),
      (e[37] = P),
      (e[38] = F))
    : (F = e[38]);
  let I;
  e[39] !== f || e[40] !== c || e[41] !== n
    ? ((I = c && (
        <CerrarProyecto
          proyecto={n}
          onClose={() => l(!1)}
          onCerrado={() => {
            (l(!1), f());
          }}
        />
      )),
      (e[39] = f),
      (e[40] = c),
      (e[41] = n),
      (e[42] = I))
    : (I = e[42]);
  let L;
  return (
    e[43] !== j || e[44] !== F || e[45] !== I
      ? ((L = <EstructuraPrincipal title={j} children={[F, I]} />),
        (e[43] = j),
        (e[44] = F),
        (e[45] = I),
        (e[46] = L))
      : (L = e[46]),
    L
  );
}
